module.exports = __webpack_public_path__ + "img/item2.18089f2b.png";